export default {
  toasted: {},
  isLoading: true,
  requestId: null,
  approversList: [],
  myApprovalRequests: []
};
